import { Outlet, Navigate } from 'react-router-dom';
import { validateAuthCookie } from 'utils/functions/authentication';

const PrivateRoute = () => {
  const isUserAuthenticated = validateAuthCookie(true);

  return isUserAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
